import {
  POLITICA_DE_PRIVACIDADE_BASE_URL,
  TERMOS_DE_USO_BASE_URL,
} from '@/config/constantes'

import { servicoBase } from '../servico-base'
import type { VerificarSeAceitouTermosResponse } from './types'

const CHAVE_DO_PRODUTO = process.env.REACT_APP_PRIVACY_POLICY_ENV

export function abrirTermosDeUso(): void {
  const url = `${TERMOS_DE_USO_BASE_URL}${CHAVE_DO_PRODUTO}`
  window.open(url, '_blank')
}

export function abrirPoliticaDePrivacidade(): void {
  const url = `${POLITICA_DE_PRIVACIDADE_BASE_URL}${CHAVE_DO_PRODUTO}`
  window.open(url, '_blank')
}

export async function verificarSeAceitouTermos(
  urlDeRetorno: string
): Promise<VerificarSeAceitouTermosResponse> {
  try {
    const { data: result } =
      await servicoBase.get<VerificarSeAceitouTermosResponse>('/v1/termos', {
        params: { urlDeRetorno },
      })

    return result
  } catch {
    return {
      url: '',
      aceito: false,
    }
  }
}
